import { render, staticRenderFns } from "./TaskApproval.vue?vue&type=template&id=6eb2fb49"
import script from "./TaskApproval.vue?vue&type=script&lang=js"
export * from "./TaskApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports